import { ApplicationRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

import { ContentPaths, ContentService, CopyService } from '@amfam/shared/utility/shared-services';
import { DockingBarService, LoadingSpinnerService, PageTitleService } from '@amfam/ui-kit';

import { TermsComponentDirective } from '../terms.component';

@Component({
  templateUrl: './know-your-drive-smartphone-terms.component.html',
  styleUrls: ['./know-your-drive-smartphone-terms.component.scss'],
  standalone: false
})
export class KnowYourDriveSmartphoneTermsComponent
  extends TermsComponentDirective
  implements OnInit, OnDestroy
{
  content: string;

  private contentSubscription: Subscription;

  constructor(
    dockingService: DockingBarService,
    route: ActivatedRoute,
    application: ApplicationRef,
    private contentService: ContentService,
    private copyService: CopyService,
    private pageTitle: PageTitleService,
    private spinner: LoadingSpinnerService
  ) {
    super(dockingService, route, application);
    this.spinner.start();
  }

  ngOnInit() {
    const contentPath: ContentPaths = 'smartphone-termsandconditions';
    super.ngOnInit();
    this.contentSubscription = this.contentService
      .getContent(contentPath, 'knowyourdrive')
      .subscribe(
        content => {
          this.content = content.richContent;
          this.spinner.stop();
          this.onContentLoad();
        },
        error => this.spinner.stop()
      );
    const title = this.copyService.get('kyd-smartphone', 'termsTitle');
    this.dockingService.registerHeading(title);
    this.pageTitle.set(title);
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    if (this.contentSubscription) {
      this.contentSubscription.unsubscribe();
    }
  }
}
